/**
 * `/support-intake` — la rotta storica dello smistamento, che dal 11-09-2026 è la scheda
 * «Da smistare» dell'hub `/support`. Rimanda lì: la rotta resta per i segnalibri, per le notifiche
 * (`supportRequestOpened` porta qui quando la richiesta è ancora in coda) e per la documentazione.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/support-intake')({
  component: () => <Navigate to="/support" hash="da-smistare" replace />,
});
